// extracted by mini-css-extract-plugin
module.exports = {"root":"sidebar_root__2Nt4a","primary":"sidebar_primary__2I3b7","secondary":"sidebar_secondary___MXWr","button":"sidebar_button__1SoBy"};